import {
    MapBoundingBoxButton,
    MapCenterMarkerButton,
    MapLayerIncidentsItem,
    MapLayerRoadRestrictionsItem,
    MapLayerSettings,
    MapLayerTrafficItem,
    MapSettings,
    MapSettingsDropdownHeader,
    MapShowMissionRouteButton,
    MapTypeSettings,
} from 'components/map/Map';
import type { VehicleFE } from 'domain/vehicle';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFollowSelectedVehicle, getShowHubs, setShowHubs } from 'store/slices/appSlice';

import { MapLayerHubItem } from './MapSettingsHubItem';

interface CustomMapSettingsProps {
    selectedVehicle?: VehicleFE;
    hasActiveMission: boolean;
    resetToBoundingBox(): void;
    unfollowSelectedVehicle(): void;
    showVehicleMissionRoute(): void;
    focusOnSelectedVehicle(): void;
}

const CustomMapSettings = ({
    selectedVehicle,
    hasActiveMission,
    resetToBoundingBox,
    showVehicleMissionRoute,
    focusOnSelectedVehicle,
}: CustomMapSettingsProps) => {
    const dispatch = useDispatch();
    const showHubs = useSelector(getShowHubs);
    const isVehicleFocused = useSelector(getFollowSelectedVehicle);

    const trafficLayers = useMemo(
        () => [
            <MapSettingsDropdownHeader key='dividerTraffic' label='Traffic overlays' />,
            <MapLayerHubItem
                key='mapLayerHubsItem'
                isActive={showHubs}
                onToggle={() => dispatch(setShowHubs(!showHubs))}
            />,
            <MapLayerTrafficItem key='mapLayerTrafficItem' label='Traffic' />,
            <MapLayerIncidentsItem key='mapLayerIncidentsItem' label='Incidents' />,
            <MapLayerRoadRestrictionsItem key='mapLayerRoadRestrictionsItem' label='Road restrictions' />,
        ],
        [showHubs, dispatch]
    );

    return (
        <MapSettings
            options={[
                <MapTypeSettings
                    key='mapTypeSettings'
                    tooltip='Change map type'
                    dropdownHeaderText='Map views'
                    defaultTypeLabel='Default view'
                    truckTypeLabel='Truck view'
                    terrainTypeLabel='Terrain view'
                    satelliteTypeLabel='Satellite view'
                    nightTypeLabel='Night view'
                />,
                <MapLayerSettings
                    key='mapLayerSettingsTraffic'
                    layers={trafficLayers}
                    tooltip='Toggle various traffic overlays'
                />,
                <MapBoundingBoxButton
                    key='mapBoundingBoxButton'
                    onToggle={resetToBoundingBox}
                    tooltip='Show all vehicles'
                />,
                <MapShowMissionRouteButton
                    key='mapShowMissionRoute'
                    isShown={hasActiveMission}
                    onClick={showVehicleMissionRoute}
                />,
                <MapCenterMarkerButton
                    key='mapCenterMarkerButton'
                    onToggle={focusOnSelectedVehicle}
                    tooltip='Center and follow'
                    isActive={isVehicleFocused}
                    className={!selectedVehicle ? 'hidden' : ''}
                />,
            ]}
        />
    );
};

export default CustomMapSettings;
